import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function VentasChart({ renovaciones, prepago, hogar, nuevas }) {
  // Sumar ingresos por cada tipo
  const sumIngresos = arr => arr.reduce((acc, it) => acc + (Number(it.planPrice) || 0), 0);

  const data = [
    { name: 'Renovaciones', Ingresos: sumIngresos(renovaciones) },
    { name: 'Prepago', Ingresos: sumIngresos(prepago) },
    { name: 'Hogar', Ingresos: sumIngresos(hogar) },
    { name: 'Ventas Nuevas', Ingresos: sumIngresos(nuevas) },
  ];

  return (
    <div style={{ width: '100%', height: 300, marginBottom: 32 }}>
      <ResponsiveContainer>
        <BarChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip formatter={v => `₡${Number(v).toLocaleString()}`} />
          <Legend />
          <Bar dataKey="Ingresos" fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
